var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShopping(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 277.89 343.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_4",
    "data-name": "Calque 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.25,343.24l-222.16.04c-16.73,0-29.06-13.85-28.03-30.29L14.08,89.71c.93-14.84,13.55-25.8,28.01-25.84l13.81-.04C61.83,27.2,93.3-.12,130.72,0l17.98.06c36.82.12,67.42,27.77,73.31,63.76l13.79.04c14.6.05,27.1,11.08,28.04,25.99l14,223.14c1,15.91-10.75,30.24-27.59,30.24ZM197.52,63.84c-5.95-24.21-27.09-39.95-51.03-39.9h-15.06c-24.35-.18-45.35,16.22-51.06,39.92l117.15-.02ZM182.77,133.04c-.28,10.45-6.13,19.33-14.44,25.32-17.25,12.44-41.41,12.46-58.67.06-8.6-6.18-14.37-15.31-14.58-25.72-.15-7.44-5.32-13.22-12.7-12.91-6.96.3-11.86,6.21-11.47,13.67.9,17.11,9.09,32.35,22.88,42.97,26.26,20.23,64.07,20.27,90.32.02,13.94-10.76,22.28-26.29,22.88-43.67.26-7.43-5.31-13.11-12.16-13-7.19.12-11.84,5.66-12.05,13.26Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping);
export default __webpack_public_path__ + "static/media/shopping.01cda4115f08ab8eb54a01a5fc49a8cf.svg";
export { ForwardRef as ReactComponent };